import styled from "styled-components";
import { Box } from "@mui/material";
import { grey } from "@mui/material/colors";

export const SocialList = styled(Box)`
	display: flex;
	align-items: center;
	justify-content: center;
	grid-gap: 10px;

	.add_social {
		width: 24px;
		height: 24px;
		border: 1px dashed ${grey[600]};
		border-radius: 5px;
		cursor: pointer;
	}
`;
